/* eslint-disable */
import React, { useEffect, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import Swal from "sweetalert2";
import GlobalApi from "../../context/api/GlobalApi";
import store from "../../context/store";
import ApiNew from "./Api";

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export default function SSoft_Footer_Demo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeLang = useSelector((state) => state.content.activeLanguage);

  const [menus, setMenus] = useState([]);
  const [subscriber, setSubscriber] = useState("");
  const [isValidEmailFormat, setIsValidEmailFormat] = useState(true);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [sectionItems, setSectionItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const api = new ApiNew();
      const menuResponse = await api.getMenuDetail({ language: activeLang });
      const sectionResponse = await api.getSectionDetail({
        language: activeLang,
      });
      const menuData = menuResponse;
      const sectionData = sectionResponse;

      setMenus(menuData.data.items);
      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let logo;
  const text1 = [];
  const text2 = [];
  let startedContent;
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;

    if (secWidgets) {
      secWidgets?.forEach((data, id) => {
        switch (id) {
          case 0:
            logo = data?.widget_contents[0];
            break;
          case 1:
            startedContent = data.widget_contents[0]?.article_language;
            break;
          case 2:
            data.widget_contents.forEach((secData) => {
              text2.push(secData.content);
            });
            break;
          default:
            break;
        }
      });
    }
  }

  const handleClick = (value) => {
    store.dispatch({
      type: "topicStore/setTopicValue",
      payload: value,
    });
    navigate(startedContent?.path);
  };

  const handleEmailChange = (event) => {
    const newSubscriber = event.target.value;
    setSubscriber(newSubscriber);
    setIsValidEmailFormat(
      newSubscriber !== "" ? isValidEmail(newSubscriber) : true
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const api = new GlobalApi();
    if (isValidEmail(subscriber)) {
      const emailData = {
        language: activeLang,
        email_data: {
          email: subscriber,
        },
        email_content: 22,
      };

      try {
        await api.sendEmail(emailData);
        // setIsEmailSent(true);
        Swal.fire("", "success", "success");
        setSubscriber("");

        // setTimeout(() => {
        //   setIsEmailSent(false);
        // }, 2000);
      } catch (err) {
        console.error(err);
      }
    } else {
      console.log("Invalid email format");
    }
  };

  return (
    <div className="w-full h-full relative">
      <div className="min-h-[110.17px] bg-cuzLightGrey">
        <div className="section-container hd:px-[120px] py-[30px] flex flex-col gap-y-2 sm:gap-y-0 sm:flex-row justify-between">
          <div>
            {logo !== "" && (
              <img
                className="w-[206px] h-[50.17px]"
                src={logo?.file}
                alt={logo?.description}
              />
            )}
          </div>
          {startedContent && (
            <div className="flex justify-between gap-x-1 xs:gap-x-[10px] md:gap-x-[30px]">
              {/* <h1 className="font-medium my-auto text-[16.5px] s:text-[18px] hd2xl:text-[22px]">
                {text2 && text2[0]}
              </h1> */}
              <div className="">
                <form
                  className="flex md:flex-row flex-col"
                  onSubmit={handleSubmit}
                >
                  <input
                    className="w-full footer-input rounded-l-[8px] s:w-[239px] bg-transparent py-[10px] outline-transparent focus:outline-none placeholder:text-cuzTurquoise !border !border-cuzDarkBlue px-2"
                    type="text"
                    placeholder={text2 && text2[1]}
                    value={subscriber}
                    onChange={handleEmailChange}
                  />
                  <button
                    type="submit"
                    className="bg-cuzTurquoise rounded-r-[8px] text-white s:w-fit font-semibold leading-[20px] hd:px-[25px] fhd:text-[18px] text-[16px]  md:px-[17px] px-[8px] cursor-pointer active:bg-cuzTurquoise/90 "
                  >
                    Subscribe newsletter
                  </button>
                </form>
                <div className="absolute mt-1 ">
                  {!isValidEmailFormat && (
                    <p className="text-cuzTurquoise text-sm">
                      {activeLang !== 3 ? "Invalid Email" : "email tidak valid"}
                    </p>
                  )}
                  {isEmailSent && (
                    <p className="text-cuzTurquoise text-sm">
                      {activeLang !== 3
                        ? "Email successfully sent"
                        : "Email berhasil terkirim"}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="w-full bg-cuzRed">
        <div className="section-container min-h-[410px] hd:px-[120px] py-[80px] flex flex-col lg:flex-row gap-y-10 lg:gap-y-0 gap-x-5 justify-between white-text">
          <div className="space-y-5 flex flex-col justify-">
            <div className="   font-medium text-[14px] leadding-tight space-y-6">
              <h1 className="font-bold text-[16px] hd2xl:text-[20px]">
                Office
              </h1>
              <div className=" space-y-[6.5px]">
                <p className="text-[16px] hd2xl:text-[20px]">
                  PT. Supersoft Sistemindo
                </p>
                <p className="text-[16px] hd2xl:text-[20px]">
                  Jl. RS. Fatmawati Raya No.12
                </p>
                <p className="text-[16px] hd2xl:text-[20px]">
                  Jakarta 12410, Indonesia
                </p>
                <p className=" text-[16px] hd2xl:text-[20px]">
                  Phone No : +62 21 3973 8310{" "}
                </p>
                {/* <p >Fax : +62 21 2991 0249</p> */}
                <p className="text-[16px] hd2xl:text-[20px]">
                  Email :{" "}
                  <a
                    href="mailto:sales@ptsupersoft.com"
                    className="underline text-[16px] hd2xl:text-[20px]"
                  >
                    sales@ptsupersoft.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="footer-menu min-w-fit flex flex-col gap-y-8 s:gap-y-0 s:flex-row justify-start s:justify-between lg:justify-end gap-x-9 md:gap-x-16 lg:gap-x-11 xl:gap-x-20">
            {menus &&
              menus.map((menu) => {
                return (
                  <div key={menu.id} className="space-y-6 w-auto">
                    <div>
                      <h1 className="font-bold text-[16px] hd2xl:text-[20px]">
                        {menu.title}
                      </h1>
                    </div>
                    <div className="space-y-[17px]">
                      {menu.children.map((child) => (
                        <p
                          key={child.id}
                          className="text-[16px] hd2xl:text-[20px]"
                        >
                          <NavHashLink
                            className={"text-[16px] hd2xl:text-[20px]"}
                            smooth
                            to={child.url || "/"}
                          >
                            {child.title}
                          </NavHashLink>
                        </p>
                      ))}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
